import { StrictMode, Suspense } from 'react';
import {
  createBrowserRouter,
  NavigateFunction,
  RouterProvider,
} from 'react-router-dom';
import { MpdLoader } from '@mapado/makeup';
import { Login, DemoLayout, Logout } from './Demo';
import { RedirectToLatestPage } from './LatestPage';
import OauthCallback from './OAuthCallback';
import { configureMoment } from './config/configureMoment';
import { configureTicketingSdk } from './config/configureTicketingSdk';
import DemoConfig from './pages/config';
import DemoEditor from './pages/editor';
import DemoLogicalSeatConfigAdmin from './pages/logicalSeatConfigAdmin';
import DemoMultiContext from './pages/multi-context';
import DemoOrderReplacement from './pages/order';
import DemoOrderManagement from './pages/orderManagement';
import DemoCartReplacement from './pages/reservation';
import DemoSeatingPlanPurchase from './pages/seatingPlanPurchase';
import DemoStockManagement from './pages/stockManagement';
import DemoOrderViewer from './pages/viewer';
import '@mapado/seating/index.css';

configureMoment();

const sdk = configureTicketingSdk();

const router = createBrowserRouter(
  [
    { index: true, element: <RedirectToLatestPage /> },
    { path: '/logout', element: <Logout ticketingSdk={sdk} /> },
    { path: '/login', element: <Login /> },
    { path: '/oauth-callback', element: <OauthCallback ticketingSdk={sdk} /> },
    {
      path: '/',
      element: (
        <DemoLayout
          onGoToLogin={(
            navigate: NavigateFunction,
            innerErrorMessage?: string
          ) => {
            const redirectUrl = `${window.location.pathname}${window.location.search}`;

            const urlSearchParams = new URLSearchParams({
              redirectUrl,
              errorMessage: innerErrorMessage || '',
            });

            navigate(`/login?${urlSearchParams.toString()}`);
          }}
          sdk={sdk}
        />
      ),
      children: [
        {
          path: 'viewer',
          element: <DemoOrderViewer />,
        },
        { path: 'stockManagement', element: <DemoStockManagement /> },

        {
          path: 'seatingPlanPurchase',
          element: <DemoSeatingPlanPurchase sdk={sdk} />,
        },

        {
          path: 'orderManagement',
          element: <DemoOrderManagement />,
        },

        {
          path: 'order',
          element: <DemoOrderReplacement />,
        },

        {
          path: 'reservation',
          element: <DemoCartReplacement />,
        },

        {
          path: 'config',
          element: <DemoConfig />,
        },

        {
          path: 'editor',
          element: <DemoEditor />,
        },

        {
          path: 'logicalSeatConfigAdmin',
          element: <DemoLogicalSeatConfigAdmin />,
        },

        {
          path: 'multi-context',
          element: <DemoMultiContext />,
        },
      ],
    },
  ],
  {
    future: {
      v7_relativeSplatPath: true,
    },
  }
);

export default function App() {
  return (
    <StrictMode>
      <Suspense fallback={<MpdLoader />}>
        <RouterProvider router={router} />
      </Suspense>
    </StrictMode>
  );
}
